import type { Result1 } from '../../types/Result1';

/**
 * Migrates a single Result1 object to ensure deadline and forIntervalEnding are present and in sync.
 * Sets version: 2 on the migrated result.
 *
 * @param result The Result1 object to migrate
 * @returns The migrated Result1 object
 */
export function migrateResult1(result: Result1): Result1 {
  // Determine the canonical date
  const deadline = result.deadline || result.forIntervalEnding;
  const forIntervalEnding = result.forIntervalEnding || result.deadline;

  let canonicalDate = deadline;
  if (deadline && forIntervalEnding && deadline !== forIntervalEnding) {
    // If both exist and differ, use the latest date
    canonicalDate = new Date(deadline) > new Date(forIntervalEnding) ? deadline : forIntervalEnding;
  }

  return {
    ...result,
    deadline: canonicalDate,
    forIntervalEnding: canonicalDate,
    version: 2,
  };
}

/**
 * Migrates an array of Result1 objects.
 *
 * @param results Array of Result1 objects
 * @returns Array of migrated Result1 objects
 */
export function migrateResult1Array(results: Result1[]): Result1[] {
  return results.map(migrateResult1);
}
